import { auth } from '@/utils/auth/auth'
import { getSessionPending, runWithSession } from '@/utils/auth/sessionGate'
import { AUTHENTICATE_PATH, LOGIN_BY_SSO_PATH } from '@/api/auth'
import { logoutEvent } from '@/pages/YouChat/utils'
import { apiRequest } from './apiRequestInit'
import {
  ApiError,
  ApiResponse,
  TRequestConfig,
  TRequestMethod,
  TRequestParams,
  isRequestMethod
} from '@gry-dmitrij/api-request'

// These requests establish the session itself, so they must never wait for it.
const SESSION_PATHS: string[] = [AUTHENTICATE_PATH, LOGIN_BY_SSO_PATH]

const reauth = () => runWithSession(auth)

const request = async <T = any>(
  method: TRequestMethod,
  url: string,
  params?: TRequestParams,
  config?: TRequestConfig
): Promise<ApiResponse<T>> => {
  if (!method) {
    throw new Error('Method is wrong')
  }

  if (!(isRequestMethod(method))) {
    throw new Error('Method is wrong')
  }

  const pendingSession = getSessionPending()
  if (pendingSession && !SESSION_PATHS.includes(url)) {
    await pendingSession
  }

  const promise = apiRequest.request(method, url, params, config)

  return promise.catch(async(err: ApiError) => {
    if (err.status === 406) {
      if (getSessionPending()) {
        return request(method, url, params, config)
      }
      try {
        await reauth()
        return apiRequest.request(method, url, params, config)
      } catch (err) {
        return Promise.reject(err)
      }
    }
    if (err.status === 401 || err.status === 422) {
      logoutEvent()
    }
    return Promise.reject(err)
  })
}

export default request
